import React, {useReducer, useEffect, useState} from 'react';
import 'url-search-params-polyfill'; // for IE

import {CustomForm, Loader, QuestionsPage, PricingTiers} from './components';
import defaultConfig from './defaultConfig';
import u20Config from './u20Config';
import {track} from './analytics';
import {Reveal} from 'react-reveal';
import {initialState, reducer} from './reducer';
const axios = require("axios").default;


export const App = ({pages, keyParam: key, privacyLink, agbLink, imprintLink, requestUrl, afterFormSuccessUrl, sendCustomerMailUrl, contact}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const {currentPageIndex, lastPageIndex, responseArray, pending, success, showForm, leadPending, leadError} = state;

  const handleSelectAnswer = (questionIndex) => {
    const currentResponse = pages[currentPageIndex].questions[questionIndex];
    const responseArrayCopy = [...responseArray];

    if (responseArrayCopy.length < currentPageIndex) {
      responseArrayCopy.push(currentResponse);
    } else {
      responseArrayCopy[currentPageIndex] = currentResponse;
    }

    dispatch({type: 'SET_RESPONSE_ARRAY', payload: responseArrayCopy});

    if (currentPageIndex + 1 < pages.length) {
      dispatch({type: 'SET_CURRENT_PAGE_INDEX', payload: currentPageIndex + 1}); // go next automatically
    } else {
      sendSurvey();
    }
  };

  const sendSurvey = async () => {
    // Skip API call - show static pricing page instead
    dispatch({type: 'SEND_SURVEY_SUCCESS', payload: {}});
  };

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const configUrl = params.get('configUrl');
  let config_id = configUrl.split("/iframe/")[1];
  if (!config_id) {
    config_id = configUrl.split("/bath/")[1];
  }

  const handleSubmitForm = async (formData) => {
    const finalResultObject = {
      public_key: key,
      config_id: config_id,
      answers: {
        property_type: responseArray[0].answer,
        property_status: responseArray[1].answer,
        person_number: responseArray[2].answer,
        bathroom_type: responseArray[3].answer,
        bathroom_size: responseArray[4].answer,
        bathroom_option: responseArray[5].answer,
        implementation_time: responseArray[6].answer,
        request_info_type: 'price',
        renovation: responseArray[1].answer !== 'new' ? 1 : 0,
        bathtub: responseArray[5].answer === 'both' ||
        responseArray[5].answer === 'bathtub' ? 1 : 0,
        shower: responseArray[5].answer === 'both' ||
        responseArray[5].answer === 'shower' ? 1 : 0,
      },
      contact: formData,
    };
    try {
      dispatch({type: 'SEND_LEAD_PENDING'});

      // Kontaktanfrage geht an den sendMail-Endpunkt (universal.dasbad3.de).
      // Der loest per config_id die Handwerker- und die Endkunden-Mail aus.
      await axios(sendCustomerMailUrl, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        data: finalResultObject,
        url: sendCustomerMailUrl
      });

      track('lead_submitted', {config_id: config_id, ...finalResultObject.answers});

      try {
        if(window && window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(JSON.stringify({'redirect': ''}));
        }

        if (window && window.parent && window.parent.postMessage && afterFormSuccessUrl) {
          window.parent.postMessage({'redirect': afterFormSuccessUrl}, '*');
          // NOTE: We want to redirect immediately, and it should not happen that the user can send it again
          // so we never fire SEND_LEAD_SUCCESS
          // dispatch({type: 'SEND_LEAD_SUCCESS'});
        } else {
          alert('Formular abgeschickt.');
        }
      } catch(err) {
        console.log(err)
      }



    } catch (e) {
      dispatch({type: 'SEND_LEAD_ERROR'});
      console.error(e);
    }
  };

  const handleGoBack = () => {
    if (currentPageIndex + 1 === virtualPaginationSize) {
      // form
      dispatch({type: 'GO_BACK_FORM', payload: currentPageIndex - 1});
    } else if (currentPageIndex + 1 === virtualPaginationSize - 1) {
      // price table
      dispatch({type: 'GO_BACK_TABLE', payload: currentPageIndex - 1});
    } else {
      dispatch({type: 'SET_CURRENT_PAGE_INDEX', payload: currentPageIndex - 1});
    }
  };

  const renderProgressBar = () => {
    return (
        <div className="paginationContainer">
          <div className="paginationNumbering">
            {currentPageIndex + 1} von <span
              className="highlighted">{virtualPaginationSize}</span>
          </div>
          <div className="progressBarContainer">
            {currentPageIndex !== 0 &&
            <i className="pointer fas fa-arrow-left fa-2x"
               onClick={handleGoBack}/>}
            <div className="progress" style={{flex: 1}}>
              <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${((currentPageIndex + 1) * 100) /
                    virtualPaginationSize}%`,
                  }}
                  aria-valuenow="50"
                  aria-valuemin="0"
                  aria-valuemax="100"
              />
            </div>
          </div>
        </div>
    );
  };

  // const renderCurrentPage = () => {
  //   const currentPage = pages[currentPageIndex];
  //
  //   const selectedQuestionFromPage = responseArray[currentPageIndex] && responseArray[currentPageIndex].answer;
  //
  //   console.log(currentPageIndex, lastPageIndex);
  //
  //   return (
  //     <Reveal
  //       effect={currentPageIndex >= lastPageIndex ? 'fadeInRight' : 'fadeInLeft'}
  //       effectOut={currentPageIndex >= lastPageIndex ? 'fadeOutLeft' : 'fadeOutRight'}
  //       key={currentPage.title}
  //     >
  //       <QuestionsPage
  //         questions={currentPage.questions}
  //         title={currentPage.title}
  //         infoBoxText={currentPage.infoBoxText}
  //         selectAnswer={handleSelectAnswer}
  //         selectedQuestionFromPage={selectedQuestionFromPage}
  //       />
  //     </Reveal>
  //   );
  // };

  const renderPages = () => {
    const content = pages.map((page, index) => {
      const selectedQuestionFromPage = responseArray[index] &&
          responseArray[index].answer;

      return (
          <div
              style={{
                position: 'absolute',
                top: 0,
                width: '100%',
                height: '100%',
                visibility: currentPageIndex === index ? 'visible' : 'hidden',
                overflow: 'hidden',
              }}
              key={index}
          >
            <Reveal
                effect={currentPageIndex >= lastPageIndex ?
                    'fadeInRight' :
                    'fadeInLeft'}
                effectOut={currentPageIndex >= lastPageIndex ?
                    'fadeOutLeft' :
                    'fadeOutRight'}
                when={currentPageIndex === index}
            >
              <QuestionsPage
                  questions={page.questions}
                  title={page.title}
                  infoBoxText={page.infoBoxText}
                  selectAnswer={handleSelectAnswer}
                  selectedQuestionFromPage={selectedQuestionFromPage}
              />
            </Reveal>
          </div>
      );
    });

    return <div style={{
      position: 'relative',
      width: '100%',
      height: '480px',
    }}>{content}</div>;
  };

  const virtualPaginationSize = pages.length + 2; //includes the 'price table' and the form

  let content = <Loader/>;

  if (!pending) {
    if (showForm) {
      content = <CustomForm
          contact={contact}
          privacyLink={privacyLink}
          agbLink={agbLink}
          leadPending={leadPending}
          leadError={leadError}
          handleSubmitForm={handleSubmitForm}
      />;
    } else if (success) {
      content = <PricingTiers
          dispatch={dispatch}
      />;
    } else {
      content = <div className={"padding"}>{renderPages()}</div>;
    }
  }

  return (
      <div className="container bottom-bar">
        <>
          {content}
          <div>{renderProgressBar()}</div>
        </>
        <div className="footer">
          <a href={imprintLink || agbLink}
             target="_blank">Impressum </a>
          |
          <a href={privacyLink}
             target="_blank"> Datenschutzerklärung</a>
        </div>
      </div>
  );
};

// Legt die U20-Overrides über eine Config. Nur Felder, die in u20Config
// gesetzt (nicht null) sind, überschreiben den jeweiligen Wert.
const withU20Overrides = (config) => {
  const overrides = {};
  Object.keys(u20Config).forEach((field) => {
    if (u20Config[field] !== null && u20Config[field] !== undefined) {
      overrides[field] = u20Config[field];
    }
  });
  return {...config, ...overrides};
};

export default () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const configUrl = params.get('configUrl');
  const [configuration, setConfiguration] = useState(null);
  const [key, setKey] = useState(null);

  useEffect(() => {
    (async () => {
      if (configUrl) {
        const result = await fetch(configUrl, {
          method: 'get',
          headers: {'Content-Type': 'application/json'},
        });
        const remoteConfiguration = await result.json();
        setConfiguration(withU20Overrides(remoteConfiguration));
        setKey(remoteConfiguration.api_key);
      } else {
        const configData = params.get('configData');
        if (configData) {
          const config = JSON.parse(configData);
          setConfiguration(withU20Overrides(config));
          setKey(config.api_key);
        }
        else {
          setConfiguration(withU20Overrides(defaultConfig));
        }

      }
    })();
  }, []);

  // Overwrite colors from remote
  useEffect(() => {
    if (configuration) {
      let root = document.documentElement;
      root.style.setProperty('--primary-color', configuration.colors.primary);
      root.style.setProperty('--secondary-color',
          configuration.colors.secondary);
      root.style.setProperty('--background-color',
          configuration.colors.background);
      root.style.setProperty('--highlight-color',
          configuration.colors.highlight);
      root.style.setProperty('--box-color', configuration.colors.box);
      root.style.setProperty('--font-color', configuration.colors.font);
    }
  }, [configuration]);

  if (!configuration) {
    return <Loader/>;
  }

  return (
      <App
          requestUrl={configuration.requestUrl}
          sendCustomerMailUrl={configuration.sendCustomerMailUrl}
          afterFormSuccessUrl={configuration.afterFormSuccessUrl}
          contact={configuration.contact}
          pages={configuration.pages}
          keyParam={key}
          privacyLink={configuration.privacyLink}
          agbLink={configuration.agbLink}
          imprintLink={configuration.imprintLink}
      />
  );
};
